import { useNavigate } from 'react-router-dom'
import { FileQuestion } from 'lucide-react'
import { Button } from '@/ui'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="w-16 h-16 rounded-2xl bg-[var(--surface-hover)] flex items-center justify-center mb-4">
        <FileQuestion className="h-8 w-8 text-[var(--text-muted)]" />
      </div>
      <h1 className="text-xl font-semibold text-[var(--text-primary)] mb-2">Page not found</h1>
      <p className="text-sm text-[var(--text-secondary)] max-w-xs mb-6">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <Button variant="primary" size="sm" onClick={() => navigate('/orders')}>
        Back to Orders
      </Button>
    </div>
  )
}
